// extracted by mini-css-extract-plugin
module.exports = {"FormMessage":"FormMessage_FormMessage__2LeRR","FormMessageError":"FormMessage_FormMessageError__3wi9b"};